module.exports = __webpack_public_path__ + "static/media/male.714f16f6.jpg";